<div
    class="prompt"
    *ngIf="testSession"
>To continue, indicate your primary purpose for taking the <span [ngClass]="testTypeCssClass">{{testSession?.testTypeDisplayName}}</span> Test:</div>

<div
    class="custom-control custom-radio"
    *ngFor="let option of primaryOptions"
>
    <input
        type="radio"
        name="test-purpose"
        [attr.id]="'option'+option.id"
        class="custom-control-input"
        value="option.id"
        [checked]="option.id == selectedOption?.id"
        (click)=setOption(option)
    />
    <label
        class="custom-control-label"
        [attr.for]="'option'+option.id"
    >{{option.name}}</label>

    <div
        style="margin-top: 0.5em; margin-bottom: 1em"
        *ngIf="option.children.length > 0 && (selectedOption?.id == option.id || selectedOption?.parentId == option.id)"
    >
        <div
            class="custom-control custom-radio"
            *ngFor="let childOption of option.children"
        >
            <input
                type="radio"
                name="test-purpose"
                [attr.id]="'option'+childOption.id"
                class="custom-control-input"
                value="childOption.id"
                [checked]="childOption.id == selectedOption?.id"
                (click)=setOption(childOption)
            />
            <label
                class="custom-control-label"
                [attr.for]="'option'+childOption.id"
            >{{childOption.name}}</label>
        </div>
    </div>
</div>
<br />
<p
    class="help-block alert alert-danger"
    *ngIf="selectedOption && selectedOption.id === 'other'"
>
    Unfortunately, other test purposes are not yet supported for the online delivery of CELPIP. Please register for Test Centre delivery for other options.
</p>
<p
    class="help-block alert alert-danger"
    *ngIf="isWebDelivery && testTypeId === TestTypeEnum.CELPIP_LS"
>
    Unfortunately, the CELPIP-General LS test is not offered for online delivery.
</p>
<p
    class="alert alert-danger"
    *ngIf="selectedOption?.testPurposeId === TestPurposeEnum.CICC && testTypeId === TestTypeEnum.CELPIP_LS"
>
    Please contact CICC to confirm that they will accept the results of the CELPIP-General LS (Listening and Speaking) Test.
</p>
<p
    class="alert alert-danger"
    *ngIf="selectedOption && selectedOption.testPurposeId === notListedPurposeId"
>
    Online registration is not available for the reason that you selected. Please <a
        href="https://www.celpip.ca/contact-us/"
        target="_blank"
    >contact our office</a> for assistance.
</p>
<p
    class="alert alert-danger"
    *ngIf="selectedOption && selectedOption.testPurposeId === TestPurposeEnum.Employment"
>
    If you are applying to the Temporary Foreign Worker Program, please select the <b>Temporary residence (TR) / permanent residence (PR) in Canada</b> option above.
</p>
<a
    href="https://college-ic.ca/"
    target="_blank"
> <img
        *ngIf="selectedOption?.testPurposeId === TestPurposeEnum.CICC"
        width="250"
        height="81"
        src="https://college-ic.ca/ICCRC/Assets/Images/System/iccrc.png"
        class="custom-logo jetpack-lazy-image jetpack-lazy-image--handled"
        alt="Image of CICC horizontal logo"
        data-lazy-loaded="1"
        loading="eager"
    ></a>


<div
    class="control-button-row"
    style="margin-top: 0.0rem; margin-bottom: 2em;"
>
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="!continueAllowed"
        (click)="clickContinue()"
    >Continue</button>
</div>
